import React from "react"
import { Link } from "gatsby"

const SearchBar = ({ searchQuery, setSearchQuery, allSpeakers }) => (
  <>
    <form
      action="/"
      method="get"
      autoComplete="off"
      className="input-group relative items-stretch w-full mb-4 -top-5"
    >
      <input
        className="relative flex-auto min-w-0 block w-full px-3 py-3
                font-normal text-gray-700 bg-white bg-clip-padding
                border border-solid border-cdfblue transition ease-in-out 
                font-mono m-0
                focus:text-gray-700 focus:bg-white shadow-solid-search focus:outline-none"
        onInput={e => setSearchQuery(e.target.value)}
        type="search"
        id="header-search"
        placeholder="Search a session / speaker / theme..."
        name="s"
      />
      <Link
        to="/advanced-search"
        className="font-mono text-orange-500 hover:bg-cdfblue hover:text-white "
      >
        &lt;<span className="underline">advanced search</span>&gt;
      </Link>
    </form>
  </>
)

export default SearchBar
